import http from "./httpService";

const apiEndpoint = "/client/ticket";

function ticketUrl(id) {
  return `${apiEndpoint}/${id}`;
}

function commentUrl(id) {
  return `${apiEndpoint}/comment/${id}`;
}

// Tickets
export function getTickets(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getTicketNav(params = {}) {
  return http.get(`${apiEndpoint}/nav`, { params });
}

export function getCounters() {
  return http.get(`${apiEndpoint}/counters/`);
}

export function getTicket(ticketid) {
  return http.get(ticketUrl(ticketid));
}

export function saveTicket(ticket) {
  if (ticket.id) {
    const body = { ...ticket };
    delete body.id;
    return http.put(ticketUrl(ticket.id), body);
  }

  return http.post(apiEndpoint, ticket);
}

export function deleteTicket(id) {
  return http.delete(ticketUrl(id));
}

// Comments
export function getComments(ticketid) {
  return http.get(commentUrl(ticketid));
}

export function saveComment(ticket) {
  return http.post(`${apiEndpoint}/comment`, ticket);
}